<template>
	<section>
		<v-footer app class="pt-3 d-print-none">
			<v-btn color="secondary" x-large @click.prevent="regresar"
				>Regresar <v-icon>chevron_left</v-icon></v-btn
			>
			<v-spacer></v-spacer>
			<v-btn color="primary" x-large @click.prevent="guardar"
				><v-icon>save</v-icon> Guardar
			</v-btn>
		</v-footer>
		<v-card>
			<v-card-text>
				<v-form ref="formPaciente">
					<v-layout row wrap>
						<v-flex xs12 text-h4 primary--text>
							Datos del paciente
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Nombre del paciente
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								@change="actualizarCURP"
								required
								:rules="[
									() =>
										!!datosPaciente.Nombres ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Nombres"
								hide-details="auto"
								label="Nombre(s)"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								@change="actualizarCURP"
								required
								:rules="[
									() =>
										!!datosPaciente.PrimerApellido ||
										'Campo requerido'
								]"
								v-model="datosPaciente.PrimerApellido"
								hide-details="auto"
								label="Primer Apellido"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								@change="actualizarCURP"
								required
								:rules="[
									() =>
										!!datosPaciente.SegundoApellido ||
										'Campo requerido'
								]"
								v-model="datosPaciente.SegundoApellido"
								hide-details="auto"
								label="Segundo Apellido"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Género
						</v-flex>
						<v-flex xs12 md8>
							<v-autocomplete
								@change="actualizarCURP"
								:items="catalogos.Generos"
								item-text="Descripcion"
								return-object
								required
								:rules="[
									() =>
										!!datosPaciente.Genero ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Genero"
								hide-details="auto"
							></v-autocomplete>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Fecha de nacimiento
						</v-flex>
						<v-flex xs12 md8 offset-md>
							<datepicker
								:max="fechaPicker(this.hoy)"
								@change="actualizarCURP"
								required
								:rules="[
									() =>
										!!datosPaciente.FechaNacimiento ||
										'Campo requerido'
								]"
								v-model="datosPaciente.FechaNacimiento"
							></datepicker>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Domicilio
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="Calle y número"
								required
								:rules="[
									() =>
										!!datosPaciente.Calle ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Calle"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="Colonia"
								required
								:rules="[
									() =>
										!!datosPaciente.Colonia ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Colonia"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								type="number"
								label="C.P."
								required
								:rules="[
									() =>
										!!datosPaciente.CodigoPostal ||
										'Campo requerido'
								]"
								v-model="datosPaciente.CodigoPostal"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Delegación/Municipio
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.DelegacionMunicipio ||
										'Campo requerido'
								]"
								v-model="datosPaciente.DelegacionMunicipio"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Estado
						</v-flex>
						<v-flex xs12 md8>
							<v-autocomplete
								@change="actualizarCURP"
								:items="catalogos.Estados"
								item-text="Descripcion"
								return-object
								required
								:rules="[
									() =>
										!!datosPaciente.Estado ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Estado"
								hide-details="auto"
							></v-autocomplete>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							CURP
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.CURP ||
										'Campo requerido'
								]"
								v-model="datosPaciente.CURP"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Escolaridad
						</v-flex>
						<v-flex xs12 md8>
							<v-autocomplete
								:items="catalogos.Escolaridades"
								item-text="Descripcion"
								return-object
								required
								:rules="[
									() =>
										!!datosPaciente.Escolaridad ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Escolaridad"
								hide-details="auto"
							></v-autocomplete>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Ocupación
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.Ocupacion ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Ocupacion"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Religión
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.Religion ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Religion"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Estado Civil
						</v-flex>
						<v-flex xs12 md8>
							<v-autocomplete
								:items="catalogos.EstadosCiviles"
								item-text="Descripcion"
								return-object
								required
								:rules="[
									() =>
										!!datosPaciente.EstadoCivil ||
										'Campo requerido'
								]"
								v-model="datosPaciente.EstadoCivil"
								hide-details="auto"
							></v-autocomplete>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Teléfono
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								type="number"
								required
								:rules="[
									() =>
										!!datosPaciente.Telefono ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Telefono"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Correo Electrónico
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								type="email"
								required
								:rules="[
									() =>
										!!datosPaciente.CorreoElectronico ||
										'Campo requerido'
								]"
								v-model="datosPaciente.CorreoElectronico"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Fecha de Ingreso
						</v-flex>
						<v-flex xs12 md8>
							<datepicker
								:max="fechaPicker(this.hoy)"
								required
								:rules="[
									() =>
										!!datosPaciente.FechaIngreso ||
										'Campo requerido'
								]"
								v-model="datosPaciente.FechaIngreso"
							></datepicker>
						</v-flex>
						<v-flex xs12 text-h4 primary--text>
							Datos del Médico Tratante
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Nombre completo
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.MedicoTratante ||
										'Campo requerido'
								]"
								v-model="datosPaciente.MedicoTratante"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Especialidad
						</v-flex>
						<v-flex xs12 md8>
							<v-autocomplete
								:items="catalogos.Especialidades"
								item-text="Descripcion"
								return-object
								required
								:rules="[
									() =>
										!!datosPaciente.Medico_Especialidad ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Medico_Especialidad"
								hide-details="auto"
							></v-autocomplete>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Domicilio
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="Calle y número"
								required
								:rules="[
									() =>
										!!datosPaciente.Medico_Calle ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Medico_Calle"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="Colonia"
								required
								:rules="[
									() =>
										!!datosPaciente.Medico_Colonia ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Medico_Colonia"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								type="number"
								label="C.P."
								required
								:rules="[
									() =>
										!!datosPaciente.Medico_CodigoPostal ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Medico_CodigoPostal"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Teléfono/Celular del Médico
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								type="number"
								required
								:rules="[
									() =>
										!!datosPaciente.Medico_Telefono ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Medico_Telefono"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 text-h4 primary--text>
							Datos del Familiar o cuidador primario
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Nombre completo
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_Nombre ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_Nombre"
								hide-details="auto"
								label="Nombre(s)"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_PrimerApellido ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_PrimerApellido"
								hide-details="auto"
								label="Primer Apellido"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_SegundoApellido ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_SegundoApellido"
								hide-details="auto"
								label="Segundo Apellido"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Parentesco
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_Parentesco ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_Parentesco"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Domicilio
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="Calle y número"
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_Calle ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_Calle"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md3>
							<v-text-field
								label="Colonia"
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_Colonia ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_Colonia"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md2>
							<v-text-field
								type="number"
								label="C.P."
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_CodigoPostal ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_CodigoPostal"
								hide-details="auto"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md4 text-h5 pt-4 pl-5>
							Teléfono/Celular del Cuidador
						</v-flex>
						<v-flex xs12 md8>
							<v-text-field
								type="number"
								required
								:rules="[
									() =>
										!!datosPaciente.Familiar_Telefono ||
										'Campo requerido'
								]"
								v-model="datosPaciente.Familiar_Telefono"
								hide-details="auto"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-form>
			</v-card-text>
		</v-card>
	</section>
</template>

<script>
import datepicker from "../../components/DatePicker.vue";
import ServicioCatalogos from "../../services/catalogos";
import ServicioPacientes from "../../services/pacientes";
import { Catalogos } from "../../services/catalogos";
export default {
	name: "nuevoPaciente",
	components: { datepicker },
	data() {
		return {
			catalogos: {
				Generos: [],
				Estados: [],
				Escolaridades: [],
				EstadosCiviles: [],
				Especialidades: []
			},
			datosPaciente: { CURP: "" },
			timeout: null
		};
	},
	methods: {
		regresar() {
			this.confirmar(
				"Regresar",
				"Desea regresar a la pantalla anterior?"
			).then(() => {
				this.$router.back();
			});
		},
		async guardar() {
			if (this.$refs.formPaciente.validate()) {
				const data = {
					...this.datosPaciente,
					GeneroCDID: this.datosPaciente.Genero.CDID,
					EstadoCDID: this.datosPaciente.Estado.CDID,
					EscolaridadCDID: this.datosPaciente.Escolaridad.CDID,
					EstadoCivilCDID: this.datosPaciente.EstadoCivil.CDID,
					Medico_EspecialidadCDID: this.datosPaciente
						.Medico_Especialidad.CDID
				};
				if (this.esEditar) {
					const res = await ServicioPacientes.editarPaciente(data);
					if (res.data.result === 1) {
						this.$root.mensajeExito =
							"El paciente se editó correctamente.";
						this.$router.replace(
							"/nutricion/perfil-paciente/" + this.pacienteId
						);
					} else {
						this.$root.mensajeError =
							res.data.message || "Error al editar el paciente.";
					}
				} else {
					const res = await ServicioPacientes.crearPaciente(data);
					if (res.data.result === 1) {
						const pacienteId = res.data.data.Table0[0].PacienteID;
						this.$root.mensajeExito =
							"El paciente se creó correctamente.";
						this.$router.replace(
							"/nutricion/perfil-paciente/" + pacienteId
						);
					} else {
						this.$root.mensajeError =
							res.data.message || "Error al crear el paciente.";
					}
				}
			}
		},
		async cargarCatalogos() {
			let res = await ServicioCatalogos.getCatalogo(Catalogos.Estados);
			this.catalogos.Estados = res.data.data.Table0;
			res = await ServicioCatalogos.getCatalogo(Catalogos.EstadoCivil);
			this.catalogos.EstadosCiviles = res.data.data.Table0;
			res = await ServicioCatalogos.getCatalogo(Catalogos.Generos);
			this.catalogos.Generos = res.data.data.Table0;
			res = await ServicioCatalogos.getCatalogo(Catalogos.Escolaridad);
			this.catalogos.Escolaridades = res.data.data.Table0;
			res = await ServicioCatalogos.getCatalogo(Catalogos.Especialidades);
			this.catalogos.Especialidades = res.data.data.Table0;
		},
		async actualizarCURP() {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			const {
				Nombres,
				PrimerApellido,
				SegundoApellido,
				FechaNacimiento,
				Estado,
				Genero
			} = this.datosPaciente;
			if (
				Nombres &&
				PrimerApellido &&
				SegundoApellido &&
				FechaNacimiento &&
				Estado &&
				Genero
			) {
				console.log("timeout");
				this.timeout = setTimeout(async () => {
					const resCURP = await ServicioPacientes.getCURP(
						Nombres,
						PrimerApellido,
						SegundoApellido,
						FechaNacimiento,
						Estado.DescripcionCorta,
						Genero.DescripcionCorta
					);
					if (resCURP.data.result === 1) {
						this.datosPaciente.CURP =
							resCURP.data.data.Table0[0].CURP;
					}
				}, 1000);
			}
		}
	},
	async mounted() {
		await this.cargarCatalogos();
		if (this.esEditar) {
			const res = await ServicioPacientes.getInfo(this.pacienteId);
			this.datosPaciente = res.data.data.Table0[0];
			this.datosPaciente.Estado = this.catalogos.Estados.find(
				e => e.CDID === this.datosPaciente.EstadoCDID
			);
			this.datosPaciente.EstadoCivil = this.catalogos.EstadosCiviles.find(
				e => e.CDID === this.datosPaciente.EstadoCivilCDID
			);
			this.datosPaciente.Genero = this.catalogos.Generos.find(
				e => e.CDID === this.datosPaciente.GeneroCDID
			);
			this.datosPaciente.Escolaridad = this.catalogos.Escolaridades.find(
				e => e.CDID === this.datosPaciente.EscolaridadCDID
			);
			this.datosPaciente.Medico_Especialidad = this.catalogos.Especialidades.find(
				e => e.CDID === this.datosPaciente.Medico_EspecialidadCDID
			);
			this.datosPaciente.FechaNacimiento = this.datosPaciente.FechaNacimiento.split(
				"T"
			)[0];
			this.datosPaciente.FechaIngreso = this.datosPaciente.FechaIngreso.split(
				"T"
			)[0];
		}
	},
	computed: {
		esEditar() {
			return this.$route.path.includes("editar");
		},
		pacienteId() {
			return this.$route.params.pacienteId;
		}
	}
};
</script>
